import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import ourTeamData from "../../data/our-team.json";
import axiosClient from "../../api/axios";


export default function Teams() {

  const [teams, setTeams] = useState([]);
  const [loadingTeams, setLoadingTeams] = useState(true);


  // Pagination params
  const [page, setPage] = useState(1);
  const limit = 9;
  const [total, setTotal] = useState(0);


  const fetchTeams = async () => {
    try {
      setLoadingTeams(true);
      // TODO - remove the hardcoded part
      const response = await axiosClient.get("/api/teams/", {
        params: { page, limit, search: "" },
      });

      setTeams(response.data.data);
    } catch (error) {
      console.error("Failed to fetch teams", error);
    } finally {
      setLoadingTeams(false);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, [page]);

  const totalPages = Math.ceil(total / limit);

  if (loadingTeams) {
    return (
      <section
        className="team-member-section ptb-100"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </section>
    );
  }

  return (
    <>
      <section className="team-member-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-4">
                <h2>{ourTeamData.title}</h2>
                <p className="lead">{ourTeamData.description}</p>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-center gap-16">
            {teams?.map((member) => (
              <div key={member.id} className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src={member?.image_url}
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">{member?.name}</h5>
                    <h6>{member?.role}</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                        <a href={member?.linkedin_url} target="_blank">
                          <span className="ti-linkedin"></span>
                        </a>
                      </li>
                      {/* <li className="list-inline-item">
                        <Link to={member.socials.facebook}>
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.twitter}>
                          <span className="ti-twitter"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.github}>
                          <span className="ti-github"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to={member.socials.dribbble}>
                          <span className="ti-dribbble"></span>
                        </Link>
                      </li> */}
                    </ul>
                    <Link
                      className="btn app-store-btn"
                      to={`/our-team/${member.id}`}
                    >
                      View details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center my-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            className="btn btn-outline-primary mx-2"
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="align-self-center">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            className="btn btn-outline-primary mx-2"
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
}
